export function createBasicLoggerStateStore(initialState = { context: {} }) {
    let statePromise = Promise.resolve(initialState);
    return {
        getState() {
            return statePromise;
        },
        async setState(update) {
            statePromise = statePromise.then(async (currState) => {
                try {
                    return await update(currState);
                }
                catch (e) {
                    console.error(e);
                }
                return currState;
            });
        },
    };
}
